import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Scrollbars } from 'react-custom-scrollbars-2';

import { DateCell } from 'common/components';
import { connect } from 'react-redux';
import { withTheme } from 'common/styling/theme';
import noInfoImage from 'common/images/noInfo.svg';
import { compose } from 'redux';
import { currentDate } from 'common/dashboards/helpers';
import UserHistoryPagination from 'backoffice/users/_components/UserHistoryPagination';
import moment from 'moment';
import MonthPicker from 'common/components/MonthPicker';
import UserNoInfoPanel from '../UserNoInfoPanel';

import { staticStyles, getDynamicStyles } from './style';

const UserLoginsHistory = ({ id, userLoginHistory, userLoginHistoryIsLoaded, theme }) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;
  const date = currentDate;
  const currentYear = Number(moment(date).add(1, 'months').format('YYYY'));
  const currentMonth = Number(moment(date).add(1, 'months').format('M'));
  const lastMonthYear = Number(moment(date).format('YYYY'));
  const lastMonth = Number(moment(date).format('M'));

  const [firstMonthValue, setFirstMonthValue] = useState({
    year: lastMonthYear,
    month: lastMonth,
  });

  const [secondMonthValue, setSecondMonthValue] = useState({
    year: currentYear,
    month: currentMonth,
  });

  const handleFirstMonthChange = monthValue => {
    setFirstMonthValue(monthValue);
  };

  const handleSecondMonthChange = monthValue => {
    setSecondMonthValue(monthValue);
  };

  return (
    <UserHistoryPagination type="login" firstMonthValue={firstMonthValue} secondMonthValue={secondMonthValue} id={id}>
      <div className="UserLoginsHistory">
        <FormattedMessage id="boUserLoginHistory">{txt => <h2>{txt}</h2>}</FormattedMessage>
        <div className="UserLoginsHistory__month-choose">
          <FormattedMessage id="justFrom">{txt => <span>{txt}</span>}</FormattedMessage>
          <MonthPicker
            monthValue={firstMonthValue}
            years={{ min: { year: 2010, month: 1 }, max: { year: currentYear, month: currentMonth } }}
            handleChange={handleFirstMonthChange}
          />
          <FormattedMessage id="justTo">{txt => <span>{txt}</span>}</FormattedMessage>
          <MonthPicker
            monthValue={secondMonthValue}
            years={{ min: { year: 2010, month: 1 }, max: { year: currentYear, month: currentMonth } }}
            handleChange={handleSecondMonthChange}
          />
        </div>
        {userLoginHistoryIsLoaded && userLoginHistory.count ? (
          <Scrollbars autoHeight autoHeightMax={500}>
            {userLoginHistory.results.map((item, index) => (
              <div className="UserLoginsHistory__info" key={index}>
                <DateCell value={item.at} />
                <p>{item.description}</p>
                {item.ip && <span>{`IP: ${item.ip}`}</span>}
              </div>
            ))}
          </Scrollbars>
        ) : (
          <UserNoInfoPanel image={noInfoImage} textId="boNoHistory" />
        )}
        <style jsx global>
          {staticStyles}
        </style>
        <style jsx global>
          {dynamicStyles}
        </style>
      </div>
    </UserHistoryPagination>
  );
};

UserLoginsHistory.propTypes = {
  id: PropTypes.string.isRequired,
  userLoginHistoryIsLoaded: PropTypes.bool.isRequired,
  userLoginHistory: PropTypes.object.isRequired,
  theme: PropTypes.object,
};

UserLoginsHistory.defaultProps = {
  theme: {},
};

export default compose(
  withTheme(),
  connect(
    state => ({
      userLoginHistoryIsLoaded: state.backoffice?.users.userLoginHistoryIsLoaded,
      userLoginHistory: state.backoffice?.users.userLoginHistory,
    }),
    {}
  )
)(UserLoginsHistory);
export { UserLoginsHistory };
